import { render } from "./Vehicles.vue?vue&type=template&id=316d9d33&scoped=true&bindings={\"addEditVehicle\":\"data\",\"dsInsert\":\"data\",\"editIndex\":\"data\",\"continueToSummary\":\"options\",\"saveVehicle\":\"options\",\"editVehicle\":\"options\",\"deleteVehicle\":\"options\",\"insertVehicle\":\"options\",\"isMakeValid\":\"options\",\"isModelValid\":\"options\",\"isRegistrationValid\":\"options\",\"isValidated\":\"options\"}"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"

import "./Vehicles.vue?vue&type=style&index=0&id=316d9d33&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-316d9d33"

export default script